import { render, staticRenderFns } from "./AppInfoCard.vue?vue&type=template&id=77a08198&scoped=true&"
import script from "./AppInfoCard.vue?vue&type=script&lang=js&"
export * from "./AppInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./AppInfoCard.vue?vue&type=style&index=0&id=77a08198&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a08198",
  null
  
)

export default component.exports